import { FiChevronRight } from 'react-icons/fi';

type Props = {
  className?: string;
};

const BreadcrumbItem: React.ReactFCWithChildren<Props> = ({ children, className = '' }) => {
  return (
    <li className={`breadcrumb-item ${className}`}>
      {children}
      <FiChevronRight size={16} className="tw-text-brand-navy" strokeWidth={2} />
    </li>
  );
};

export default BreadcrumbItem;
